var $ = require('jquery');

var ps = require('../lib/ps');

var Class = require('../lib/Class');

 /**
  * Base widget
  * @class
  */
var _Base = Class.extend(
  /** @lends _Base.prototype */
  {
  /**
   * _Base widget initialisation method that creates widget options and defines this.$el
   * @private
   */
  _init: function(el) {
    var self = this;
    this.$el = $(el);
    this.widgetOptions = this.$el.data('widgetOptions') ? this.$el.data('widgetOptions') : {};
    this.parsed = false;

    if (typeof this.init === 'function') {
      this.init();
    }

    ps.subscribeOnce('parser:parseComplete', function(event) {
      self.parsed = true;
      if (typeof self.onWidgetsReady === 'function') {
        self.onWidgetsReady();
      }
    });
  }
});

module.exports = _Base;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/_Base.js
 ** module id = 10
 ** module chunks = 0 1
 **/